import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import { hot } from 'react-hot-loader';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';

import TitleContainer from './components/title-container/TitleContainer';
import EirFormContainer from './components/eir-form-container/EirFormContainer';
import EirBBInfoResultContainer from './components/eir-bbinforesult-container/EirBBInfoResultContainer';
import EirCardContainer from './components/eircard-container/EirCardContainer';
import EirDeviceListContainer from './components/eir-device-list-container/EirDeviceListContainer';
import EirDeviceDetailsContainer from './components/eir-device-details-container/EirDeviceDetailsContainer';
import FAQContainer from './components/faq-container/FAQContainer';
import LeftRight from './components/leftright/LeftRight';
import Footer from './components/footer/Footer';
import HeaderContainer from './components/HeaderContainer';
import ThreeTileBanner from './components/three-tile-banner/ThreeTileBanner';
import ThreeColumn from './components/three-column/ThreeColumn';
import TwoFourColumn from './components/two-four-column/TwoFourColumn';
import ThreeSixColumn from './components/three-six-column/ThreeSixColumn';
import EirBusinessProductTile from './components/eir-business-product-tile/EirBusinessProductTile';
import EirTopModule from './components/eir-top-module/EirTopModule';
import EirTutorials from './components/eir-tutorials/EirTutorials';
import EirPhoneListings from './components/eir-phone-listings/EirPhoneListings';
import EirTabModule from './components/eir-tab-module/EirTabModule';
import ContentCarousel from './components/content-carousel/ContentCarousel';
import Breadcrumb from './components/breadcrumb/Breadcrumb';
import FullWidthBanner from './components/fullwidth-banner/FullWidthBanner';
import Paragraph from './components/paragraph/Paragraph';
import ModalContainer from './components/modal-container/ModalContainer';
import FullWidthVideoBanner from './components/eir-fullwidth-video-banner/FullWidthVideoBanner';
import Polyfills from './utils/Polyfills';
import TVChannels from './components/tv-channels/TvChannels';
import './scss/app.scss';
import EirFeaturesBenefits from './components/eir-features-benefits/EirFeaturesBenefits';
import EirApp from './components/eir-app/EirApp';
import EirOnlineForm from './components/eir-online-forms/EirOnlineFormLandingPage';
import EirWebmailLogin from './components/eir-webmail/EirWebmailLogin';
import EirWebmailLoginRedirect from './components/eir-webmail/EirWebmailLoginRedirect';
import AccountManagement from './components/eir-webmail/account-management/AccountManagement';
import EirWebmailContainer from './components/eir-webmail/EirWebmailContainer';
import EirWebmailPayment from './components/eir-webmail/EirWebmailPayment';
import '../public/images/green-tick.png';
import '../public/images/eir-cart-icon.svg';
import '../public/images/arrow-lb-left.png';
import '../public/images/arrow-lb-left-hover.png';
import '../public/images/arrow-lb-right.png';
import '../public/images/arrow-lb-right-hover.png';
import EirOnlineFormBuilder from './components/eir-online-forms/EirOnlineFormBuilder';
import EirNotificationBanner from './components/eir-notification-banner/EirNotificationBanner';
import EirCheckoutContainer from './components/eir-checkout/EirCheckoutContainer';
import EirHelpAndSupport from './components/eir-help-and-support/EirHelpAndSupport';
import EirFullWidthCarousel from './components/fullwidth-carousel/EirFullWidthCarousel';
import EirResponsiveCarousel from './components/responsive-carousel/EirResponsiveCarouselSwiper';
import EirOffers from './components/eir-offers/EirOffers';
import EirQuickLinksPanel from './components/eir-quicklinks-panel/EirQuickLinksPanel';
import EirReasonsToChooseEir from './components/eir-reasons-to-choose-eir/EirReasonsToChooseEir';
import EirBundleCardToggle from './components/eir-bundle-card-toggle/EirBundleCardToggle';
import EirSticky from './components/eir-sticky/EirSticky';
import EirContactUs from './components/eir-contact-us/EirContactUs';
import EirMobileCardContainer from './components/eir-mobile-card-container/EirMobileCardContainer';
import EirPrepayPhoneDetails from './components/eir-prepay-device-details/EirPrepayDeviceDetailsContainer';
import EirHandsetContainer from './components/eir-handset-container/EirHandsetContainer';
import EirTwoColumnAccordion from './components/eir-two-column-accordion/EirTwoColumnAccordion';
import EirLeftMenuRightContent from './components/eir-leftmenu-rightcontent/EirLeftMenuRightContent';
import EirLeftMenu from './components/eir-leftmenu/EirLeftMenu';
import EirCustomiseCheckout from './components/eir-customise-checkout/EirCustomiseCheckout';
import EirListModule from './components/eir-list-module/EirListModule';
import EirBusinessAccordion from './components/eir-business-lb-accordion/EirBusinessLbAccordion';
import EirTestimonial from './components/Testimonial/EirTestimonial';
import EirCustomiseTvChannels from './components/eir-customise-checkout/eir-customise-tv/EirCustomiseTvChannels';
import EirCustomiseHomePhone from './components/eir-customise-checkout/eir-customise-broadband/EirCustomiseHomePhone';
import EirCustomerCheckoutContainer from './components/eir-payment/EirCustomerCheckoutContainer';
import EirPrequalDetailsContainer from './components/eir-prequal-container/EirPrequalDetailsContainer';
import EirOrderContainer from './components/eir-order-container/EirOrderContainer';
import EirFixedBundleCardContainer from './components/eir-prequal-container/EirFixedBundleCardContainer';
import EirPrequalNoResult from './components/eir-prequal-container/EirPrequalNoResult';
import EirPrequalInputContainer from './components/eir-prequal-container/EirPrequalInputContainer';
import { initWebChatFocusOrder } from './utils/useWebchatFocusOrder';

const client = new ApolloClient({
  uri: `${window.location.origin}/graphql/`,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    }
  }
});
const components = {
  'eir-online-forms-builder': EirOnlineFormBuilder,
  'eir-online-forms': EirOnlineForm,
  'eir-webmail-account-management': AccountManagement,
  'eir-app': EirApp,
  'tv-channels': TVChannels,
  'eir-features-benefits': EirFeaturesBenefits,
  'eir-title': TitleContainer,
  'eir-form-container': EirFormContainer,
  'eir-bbinforesult-container': EirBBInfoResultContainer,
  'eir-bundle-offer-container': EirCardContainer,
  'eir-device-list-container': EirDeviceListContainer,
  'eir-device-details-container': EirDeviceDetailsContainer,
  'eir-faq-container': FAQContainer,
  'eir-footer': Footer,
  'eir-header': HeaderContainer,
  'eir-left-right': LeftRight,
  'eir-three-tile-banner': ThreeTileBanner,
  'eir-fullwidth-banner': FullWidthBanner,
  'eir-fullwidth-video-banner': FullWidthVideoBanner,
  'eir-paragraph': Paragraph,
  'eir-three-column': ThreeColumn,
  'eir-two-four-column': TwoFourColumn,
  'eir-three-six-column': ThreeSixColumn,
  'eir-business-product-tile': EirBusinessProductTile,
  'eir-top-module': EirTopModule,
  'eir-tutorial': EirTutorials,
  'eir-tab-module': EirTabModule,
  'eir-phone-listings': EirPhoneListings,
  'eir-content-carousel': ContentCarousel,
  'eir-breadcrumb': Breadcrumb,
  'eir-webmail-login': EirWebmailLogin,
  'eir-webmail-login-redirect': EirWebmailLoginRedirect,
  'eir-webmail-container': EirWebmailContainer,
  'eir-webmail-payment': EirWebmailPayment,
  'eir-notification-banner': EirNotificationBanner,
  'eir-checkout-container': EirCheckoutContainer,
  'eir-prepay-phone-details': EirPrepayPhoneDetails,
  'eir-handset-container': EirHandsetContainer,
  'eir-mobile-card-container': EirMobileCardContainer,
  'eir-help-and-support': EirHelpAndSupport,
  'eir-fullwidth-carousel': EirFullWidthCarousel,
  'eir-responsive-carousel': EirResponsiveCarousel,
  'eir-offers': EirOffers,
  'eir-quicklinks-panel': EirQuickLinksPanel,
  'eir-reasons-to-choose-eir': EirReasonsToChooseEir,
  'eir-bundle-card-toggle': EirBundleCardToggle,
  'eir-sticky': EirSticky,
  'eir-contact-us': EirContactUs,
  'eir-two-column-accordion': EirTwoColumnAccordion,
  'eir-leftmenu-right-content': EirLeftMenuRightContent,
  'eir-leftmenu': EirLeftMenu,
  'eir-customise-checkout': EirCustomiseCheckout,
  'eir-list-module': EirListModule,
  'eir-accordion-module': EirBusinessAccordion,
  'eir-testimonial': EirTestimonial,
  'eir-customise-tv-channels': EirCustomiseTvChannels,
  'eir-customise-order-summary': EirCustomiseHomePhone,
  'eir-payment-container': EirCustomerCheckoutContainer,
  'eir-prequal-container': EirPrequalDetailsContainer,
  'eir-order-container': EirOrderContainer,
  'eir-fixedbundle-card-container': EirFixedBundleCardContainer,
  'eir-prequal-noresult': EirPrequalNoResult,
  'eir-prequal-input-container': EirPrequalInputContainer
};

Polyfills.addPolyfills(() => {
  // Web chat focus order
  initWebChatFocusOrder();

  let isKeyboardNavigation = false;

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      isKeyboardNavigation = true;
    }
  });

  document.addEventListener('mousedown', () => {
    isKeyboardNavigation = false;
  });

  function handleFocus(e) {
    const el = e.target;

    if (!(el instanceof Element)) return;
    if (!(el.tabIndex >= 0 && el.matches(':focus-visible'))) return;
    const getClosestBackgroundColor = element => {
      let current = element.parentElement;

      while (current) {
        // stop if this is the carousel container or contains a carousel bg image
        if (
          current.classList.contains('responsive-carousel-container') ||
          current.querySelector(':scope > .carousel-slide-bg-img-container')
        ) {
          return '#493553';
        }

        const style = window.getComputedStyle(current);
        const bgColor = style.backgroundColor;

        if (bgColor && !bgColor.includes('rgba(0, 0, 0, 0)') && bgColor !== 'transparent') {
          return bgColor;
        }

        current = current.parentElement;
      }

      return '#493553';
    };

    const bg = getClosestBackgroundColor(el);

    const isLight = hex => {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
      return luminance > 180;
    };

    const toHex = rgb => {
      const [r, g, b] = rgb.match(/\d+/g).map(Number);
      return `#${[r, g, b].map(n => n.toString(16).padStart(2, '0')).join('')}`;
    };

    const hex = bg.startsWith('#') ? bg : toHex(bg);
    const outerColor = isLight(hex) ? '#DD1D78' : '#F5EBDA';

    // outline = outer colored ring (does NOT follow border-radius, always sharp rectangle)
    // box-shadow layer 1 = white inner ring (2px), sits at 3px from element  
    // box-shadow layer 2 = bg color gap (3px), hides the space between element and white ring
    el.style.setProperty('outline', `2px solid #493553`, 'important');
    el.style.setProperty('outline-offset', '5px', 'important'); // 3px gap + 2px white ring
    el.style.setProperty(
      'box-shadow',
      `0 0 0 3px ${bg}, 0 0 0 5px white, 0 0 0 7px #493553`,
      'important'
    );
    el.style.setProperty('outline', 'none', 'important');
    el.style.setProperty('border-radius', '3px', 'important');
  }
  function handleBlur(e) {
    const el = e.target;
    if (!(el instanceof Element)) return;

    if (el.tabIndex >= 0) {
      el.style.boxShadow = '';
      el.style.outline = '';
      el.style.borderRadius = '';
    }
  }
  document.addEventListener('focusin', handleFocus, true);
  document.addEventListener('focusout', handleBlur, true);

  //add a modal component to the page for other components to use
  const body = document.getElementById('body');
  if (body) {
    const modalPlaceholder = document.createElement('div');
    modalPlaceholder.id = 'eir-modal-placeholder';
    body.insertBefore(modalPlaceholder, body.firstChild);
    render(<ModalContainer />, modalPlaceholder);
  }

  /**
  This can potentially be moved to App.js which would allow index to render <App />
  This would allow for state to be controlled inside of App.

  import App from "./App";
render(<Router />, document.querySelector("#main"));

  Chane the export default hot(module); to export default hot(App) to enable hot module
  reload.

**/

  window.components.forEach(component => {
    const element = document.getElementById(`${component.id}`);
    const Component = components[component.type];

    //cookie-pro banner focus
    let hasFocusedBanner = false;
    window.onkeydown = e => {
      if (e.key === 'Tab' && !hasFocusedBanner) {
        const banner = document.getElementById('onetrust-banner-sdk');
        if (banner && e.key === 'Tab' && !hasFocusedBanner) {
          banner.setAttribute('tabindex', '0');
          banner.focus();
          hasFocusedBanner = true;
        }
      }
    };

    if (Component) {
      render(
        <ApolloProvider client={client}>
          <Component {...component.cmsContent} />
        </ApolloProvider>,
        element
      );
    }
  });
})

export default hot(module);
